const config = {
  OP_LOG_IDS: {
    bizId: 1,
    teacherInTenantResourceId: 1, // 教务系统 - 管理员信息修改
  },
  MAIN_APP_URL: 'https://laoshi.feixiangxingqiu.com',
  lectioPrivacy: 'https://ke.feixiangxingqiu.com/policy/lectio-privacy.html',
  lectioChildPrivacy: 'https://ke.feixiangxingqiu.com/policy/lectio-child-privacy.html',
  zhzxjsPrivacy: 'https://ke.feixiangxingqiu.com/policy/zhzxjs-privacy.html',
  zhzxjsChildPrivacy: 'https://ke.feixiangxingqiu.com/policy/zhzxjs-child-privacy.html',
  attendClass: 'https://ke.feixiangxingqiu.com/#/attend-class-v2',
  lessonDetail: 'https://ke.feixiangxingqiu.com/#/lesson/detail/',
}

export default config
